import AndreiDuvin from '../../../assets/img/speakers-photo/Andrei_Duvin.jpg'
import AnnaSotneva from '../../../assets/img/speakers-photo/anna_sotneva.jpg'
import DaniilLebedev from '../../../assets/img/speakers-photo/Daniil_Lebedev.jpg'
import DmitryKornev from '../../../assets/img/speakers-photo/Dmitry_Kornev.jpg'
import EkaterinaChuvatkina from '../../../assets/img/speakers-photo/Ekaterina_Chuvatkina.jpg'
import ElenaMakhalina from '../../../assets/img/speakers-photo/Elena_Makhalina.jpg'
import IgorRudim from '../../../assets/img/speakers-photo/igor_rudim.jpg'
import KonstantinZamkov from '../../../assets/img/speakers-photo/konstantin_zamkov.jpg'
import KseniaSimakova from '../../../assets/img/speakers-photo/Ksenia_Simakova.jpg'
import NataliaMakarova from '../../../assets/img/speakers-photo/natalia_makarova.jpg'
import SergeyLysokobylka from '../../../assets/img/speakers-photo/Sergey_Lysokobylka.jpg'
import TamaraRau from '../../../assets/img/speakers-photo/tamara_rau.jpg'
import VladimirSlinko from '../../../assets/img/speakers-photo/Vladimir_Slinko.jpg'


export default [
    {
        name: 'Игорь Рудым',
        post: 'Директор по развитию серверного рынка Intel',
        photo: IgorRudim
    },
    {
        name: 'Наталья Макарова',
        post: 'Директор по работе с банковским сектором',
        photo: NataliaMakarova
    },
    {
        name: 'Константин Замков',
        post: 'Менеджер по развитию бизнеса',
        photo: KonstantinZamkov
    },
    {
        name: 'Анна Сотнева',
        post: 'Менеджер по развитию проектов',
        photo: AnnaSotneva
    },
    {
        name: 'Тамара Рау',
        post: 'Инженер по продажам',
        photo: TamaraRau
    },
    {
        name: 'Елена Махалина',
        post: 'Менеджер по работе с дистрибуцией Intel',
        photo: ElenaMakhalina
    },
    {
        name: 'Даниил Лебедев',
        post: 'Менеджер по работе с дистрибуцией Intel',
        photo: DaniilLebedev
    },
    {
        name: 'Дмитрий Корнев',
        post: 'Менеджер по развитию партнерского бизнеса Intel в России',
        photo: DmitryKornev
    },
    {
        name: 'Владимир Слинько',
        post: 'Менеджер по развитию проектов интернета вещей',
        photo: VladimirSlinko
    },
    {
        name: 'Андрей Дувин',
        post: 'Менеджер по развитию продаж в сегменте IoT',
        photo: AndreiDuvin
    },
    {
        name: 'Ксения Симакова',
        post: 'Инженер по применению продукции Intel в сегменте IoT',
        photo: KseniaSimakova
    },
    {
        name: 'Сергей Лысокобылка',
        post: 'Менеджер по развитию бизнеса локальных интеграторов',
        photo: SergeyLysokobylka
    },
    {
        name: 'Екатерина Чуваткина',
        post: 'Инженер по применению продукции Intel',
        photo: EkaterinaChuvatkina
    }
]
